import { Icons } from '@/app/components/ui/Icons'
import { FC } from 'react'

export interface Props {
	count: number
	className?: string
	fill?: string
	size?: string
}

const Stars: FC<Props> = ({ count, className, size = '16', fill }) => {
	return (
		<div
			data-test-id="stars-component"
			data-stars={count}
			className={className}
		>
			{new Array(count).fill(0).map((_, i) => {
				return <Icons.star key={i} width={size} height={size} fill={fill || "#F4BF00"} />
			})}
		</div>
	)
}

export default Stars
